class MobileMenu {
  constructor() {
    this.menu = document.querySelector(".site-header__menu")
    this.openButton = document.querySelector(".site-header__menu-trigger")
    this.menuItems = document.querySelectorAll('.menu-item-has-children')
    this.events()
  }

  events() {
    this.openButton.addEventListener("click", () => this.openMenu())
    
    if (window.innerWidth < 980) {
      // Handle parent menu item clicks
      this.menuItems.forEach(item => {
        const link = item.querySelector('a')
        link.addEventListener('click', (e) => {
          e.preventDefault()
          e.stopPropagation()
          this.toggleSubmenu(item)
        })
      })
    }
  }

  toggleSubmenu(item) {
    // Close other open submenus
    this.menuItems.forEach(otherItem => {
      if (otherItem !== item && otherItem.classList.contains('submenu-active')) {
        otherItem.classList.remove('submenu-active')
      }
    })
    
    // Toggle current submenu
    item.classList.toggle('submenu-active')
  }

  openMenu() {
    this.openButton.classList.toggle("fa-bars")
    this.openButton.classList.toggle("fa-window-close")
    this.menu.classList.toggle("site-header__menu--active")
  }
}

export default MobileMenu
